import { toast, ToastOptions } from "react-toastify";

export const SuccessOptions = (callback?: () => void, delay?: number): ToastOptions => {
    return { position: toast.POSITION.BOTTOM_CENTER, autoClose: delay ?? 2500, onClose: () => callback?.() };
};

export const ErrorOptions = (callback?: () => void, delay?: number): ToastOptions => {
    return { position: toast.POSITION.BOTTOM_CENTER, autoClose: delay ?? 6000, onClose: () => callback?.() };
};

export const WarningOptions = (callback?: () => void, delay?: number): ToastOptions => {
    return { position: toast.POSITION.TOP_CENTER, autoClose: delay ?? 7000, onClose: () => callback?.() };
};
